const cssMap = {
  '/assets/snapbase_blue.css': '#2C3E50',
  '/assets/snapbase_water.css': '#3498DB',
  '/assets/snapbase_turquoise.css': '#1ABC9C',
  '/assets/snapbase_emerald.css': '#2ecc71',
  '/assets/snapbase_amethyst.css': '#9b59b6',
  '/assets/snapbase_alizarin.css': '#e74c3c',
  '/assets/snapbase_red.css': '#c2070a',
  '/assets/snapbase_carrot.css': '#E67E22',
  '/assets/snapbase_orange.css': '#F39C12',
  '/assets/snapbase_silver.css': '#BDC3C7',
  '/assets/snapbase_brown.css': '#443B31',
};

export function colorFromCss(css) {
  return cssMap[css];
}
